export const loadCompaniesAnnuaire = (payload) => ({
    type: 'loadCompanies',
    payload
});

export const setActiveSelectorAnnuaire = (payload) => ({
    type: 'setActiveSelector',
    payload
})